<div class="aca-admin aca-wfb">
  <aca-page-header [bare]="embedded" icon="account_tree" [title]="'DMS.WORKFLOW_BUILDER.050EB5' | translate" [subtitle]="'DMS.UI.8C31F2' | translate">
    <button type="button" class="aca-wfb__outline" routerLink="/workflow">
      <mat-icon>fact_check</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.F625BE' | translate }}
    </button>
    <button type="button" class="aca-wfb__primary" (click)="newTemplate()">
      <mat-icon>add</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.5DCB54' | translate }}
    </button>
  </aca-page-header>

  <!-- ── summary ────────────────────────────────────────────────────────── -->
  <div class="aca-wfb__stats">
    <div class="aca-wfb__stat">
      <span class="aca-wfb__staticon aca-wfb__staticon--blue"><mat-icon>play_circle</mat-icon></span>
      <span class="aca-wfb__stattext">
        <span class="aca-wfb__statlabel">{{ 'DMS.WORKFLOW_BUILDER.86F166' | translate }}</span>
        <span class="aca-wfb__statvalue">{{ activeProcesses() | number }}</span>
        <span class="aca-wfb__statunit">{{ 'DMS.WORKFLOW_BUILDER.A4D48B' | translate }}</span>
      </span>
    </div>
    <div class="aca-wfb__stat">
      <span class="aca-wfb__staticon aca-wfb__staticon--purple"><mat-icon>schema</mat-icon></span>
      <span class="aca-wfb__stattext">
        <span class="aca-wfb__statlabel">{{ 'DMS.WORKFLOW_BUILDER.4D63E5' | translate }}</span>
        <span class="aca-wfb__statvalue">{{ engineDefinitions() | number }}</span>
        <span class="aca-wfb__statunit">{{ 'DMS.WORKFLOW_BUILDER.B197FA' | translate }}</span>
      </span>
    </div>
    <div class="aca-wfb__stat">
      <span class="aca-wfb__staticon aca-wfb__staticon--amber"><mat-icon>edit_note</mat-icon></span>
      <span class="aca-wfb__stattext">
        <span class="aca-wfb__statlabel">{{ 'DMS.WORKFLOW_BUILDER.9E2DFC' | translate }}</span>
        <span class="aca-wfb__statvalue">{{ templates().length | number }}</span>
        <span class="aca-wfb__statunit">{{ 'DMS.WORKFLOW_BUILDER.BF7562' | translate }}</span>
      </span>
    </div>
    <div class="aca-wfb__stat">
      <span class="aca-wfb__staticon aca-wfb__staticon--green"><mat-icon>timeline</mat-icon></span>
      <span class="aca-wfb__stattext">
        <span class="aca-wfb__statlabel">{{ 'DMS.WORKFLOW_BUILDER.92EC00' | translate }}</span>
        <span class="aca-wfb__statvalue">{{ instances().length | number }}</span>
        <span class="aca-wfb__statunit">{{ 'DMS.WORKFLOW_BUILDER.51C19F' | translate }}</span>
      </span>
    </div>
  </div>

  <div class="aca-wfb__notice">
    <mat-icon>info</mat-icon>
    <p>{{ 'DMS.FLOW.NOTICE' | translate }}</p>
  </div>

  <!-- ── template list ──────────────────────────────────────────────────── -->
  <ng-container *ngIf="!editing">
    <aca-page-state
      *ngIf="!templates().length && !instances().length"
      state="empty"
      icon="account_tree"
      [title]="'DMS.WORKFLOW_BUILDER.D4C4E4' | translate"
      [message]="'DMS.UI.678275' | translate"
    />

    <section class="aca-wfb__card" *ngIf="templates().length">
      <h3 class="aca-wfb__cardtitle">{{ 'DMS.WORKFLOW_BUILDER.4692A5' | translate }}</h3>
      <ul class="aca-wfb__list">
        <li class="aca-wfb__row" *ngFor="let tpl of templates()">
          <span class="aca-wfb__rowicon"><mat-icon>schema</mat-icon></span>
          <span class="aca-wfb__rowmain">
            <span class="aca-wfb__rowtitle">{{ tpl.name }}</span>
            <span class="aca-wfb__rowmeta"
              >{{ stepCount(tpl) }} {{ 'DMS.UI.2F69C8' | translate }}<span *ngIf="tpl.description"> · {{ tpl.description }}</span></span
            >
          </span>
          <span
            class="aca-wfb__chip aca-wfb__chip--{{ state(tpl) }}"
            [matTooltip]="'DMS.FLOW.STATE_' + (state(tpl) | uppercase) + '_HINT' | translate"
          >
            {{ 'DMS.FLOW.STATE_' + (state(tpl) | uppercase) | translate: { p0: tpl.deployment?.templateVersion } }}
          </span>
          <span class="aca-wfb__rowactions">
            <button type="button" class="aca-wfb__primary" (click)="runTemplate(tpl)" [disabled]="busy()">
              <mat-icon>play_arrow</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.5D840B' | translate }}
            </button>
            <button
              mat-icon-button
              (click)="editTemplate(tpl)"
              [matTooltip]="'DMS.WORKFLOW_BUILDER.E7ECA5' | translate"
              [attr.aria-label]="'DMS.WORKFLOW_BUILDER.E7ECA5' | translate"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="deleteTemplate(tpl)"
              [matTooltip]="'DMS.WORKFLOW_BUILDER.F535FD' | translate"
              [attr.aria-label]="'DMS.WORKFLOW_BUILDER.F535FD' | translate"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </li>
      </ul>
    </section>

    <section class="aca-wfb__card" *ngIf="instances().length">
      <h3 class="aca-wfb__cardtitle">{{ 'DMS.WORKFLOW_BUILDER.AB81BD' | translate }}</h3>
      <ul class="aca-wfb__list">
        <li class="aca-wfb__row" *ngFor="let inst of instances()">
          <span class="aca-wfb__rowicon aca-wfb__rowicon--amber"><mat-icon>timeline</mat-icon></span>
          <span class="aca-wfb__rowmain">
            <span class="aca-wfb__rowtitle">{{ inst.templateName }}</span>
            <span class="aca-wfb__rowmeta"
              >{{ 'DMS.UI.D0F6A6' | translate }} {{ inst.currentStep + 1 }} · {{ 'DMS.UI.A298C5' | translate
              }}{{ inst.startedAt | acaDate: 'd MMM y HH:mm' }}</span
            >
          </span>
          <span class="aca-wfb__chip">{{ inst.status }}</span>
        </li>
      </ul>
    </section>
  </ng-container>

  <!-- ── editor: palette | graph | properties ───────────────────────────── -->
  <div class="aca-wfb__editor" *ngIf="editing as tpl">
    <!-- palette -->
    <aside class="aca-wfb__palette">
      <h3 class="aca-wfb__panetitle">{{ 'DMS.WORKFLOW_BUILDER.C1E3F4' | translate }}</h3>
      <p class="aca-wfb__panehint">{{ 'DMS.FLOW.PALETTE_HINT' | translate }}</p>
      <button
        type="button"
        class="aca-wfb__paletteitem"
        *ngFor="let p of paletteKinds"
        (click)="addNode(p.kind)"
        [matTooltip]="p.hint | translate"
        matTooltipPosition="right"
      >
        <span class="aca-wfb__paletteicon" [ngClass]="'aca-wfb__paletteicon--' + p.tone"
          ><mat-icon>{{ icons[p.kind] }}</mat-icon></span
        >
        <span class="aca-wfb__palettelabel">{{ p.label | translate }}</span>
      </button>
      <p class="aca-wfb__panehint aca-wfb__howto">{{ 'DMS.FLOW.HOWTO' | translate }}</p>
    </aside>

    <!-- the graph -->
    <section class="aca-wfb__canvas">
      <div class="aca-wfb__canvashead">
        <input
          class="aca-wfb__nameinput"
          [(ngModel)]="tpl.name"
          (ngModelChange)="dirty = true"
          [placeholder]="'DMS.WORKFLOW_BUILDER.6B4766' | translate"
          [attr.aria-label]="'DMS.WORKFLOW_BUILDER.6B4766' | translate"
        />
        <span class="aca-wfb__chip aca-wfb__chip--{{ state(tpl) }}">
          {{ 'DMS.FLOW.STATE_' + (state(tpl) | uppercase) | translate: { p0: tpl.deployment?.templateVersion } }}
        </span>
        <span class="aca-wfb__chip aca-wfb__chip--changed" *ngIf="dirty">{{ 'DMS.FLOW.UNSAVED' | translate }}</span>
      </div>

      <p class="aca-wfb__converted" *ngIf="converted"><mat-icon>auto_fix_high</mat-icon>{{ 'DMS.FLOW.CONVERTED' | translate }}</p>

      <!-- catalogue fields the cards on the start page read -->
      <div class="aca-wfb__metafields">
        <label class="aca-wfb__metafield">
          <span>{{ 'DMS.WIZARD.CATEGORY' | translate }}</span>
          <input [(ngModel)]="tpl.category" placeholder="custom" />
        </label>
        <label class="aca-wfb__metafield">
          <span>SLA ({{ 'DMS.MANAGE.DAYS' | translate }})</span>
          <input type="number" min="0" [(ngModel)]="tpl.slaDays" />
        </label>
        <label class="aca-wfb__metafield aca-wfb__metafield--wide">
          <span>{{ 'DMS.WIZARD.NO_DESCRIPTION' | translate }}</span>
          <input [(ngModel)]="tpl.description" />
        </label>
      </div>

      <!-- visibility gate — who may see and start this flow -->
      <div class="aca-wfb__vis">
        <label class="aca-wfb__check">
          <input type="checkbox" [(ngModel)]="tpl.restricted" />
          <span>{{ 'DMS.BUILDER.VIS_RESTRICT' | translate }}</span>
        </label>
        <p class="aca-wfb__vishint" *ngIf="tpl.restricted">{{ 'DMS.BUILDER.VIS_HINT' | translate }}</p>
        <div class="aca-wfb__vislists" *ngIf="tpl.restricted">
          <div class="aca-wfb__visrow">
            <span class="aca-wfb__vistitle"><mat-icon>person</mat-icon>{{ 'DMS.BUILDER.VIS_USERS' | translate }}</span>
            <span class="aca-wfb__vchip" *ngFor="let u of tpl.allowedUsers ?? []; let i = index">
              {{ u.displayName }}
              <button type="button" class="aca-wfb__vchipx" (click)="removeAllowed('user', i)" [attr.aria-label]="'DMS.UI.55C866' | translate">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            <button type="button" class="aca-wfb__outline aca-wfb__vadd" (click)="addAllowed('user')">
              <mat-icon>person_add</mat-icon>{{ 'DMS.BUILDER.VIS_ADD_USER' | translate }}
            </button>
          </div>
          <div class="aca-wfb__visrow">
            <span class="aca-wfb__vistitle"><mat-icon>groups</mat-icon>{{ 'DMS.BUILDER.VIS_GROUPS' | translate }}</span>
            <span class="aca-wfb__vchip" *ngFor="let g of tpl.allowedGroups ?? []; let i = index">
              {{ g.displayName }}
              <button type="button" class="aca-wfb__vchipx" (click)="removeAllowed('group', i)" [attr.aria-label]="'DMS.UI.55C866' | translate">
                <mat-icon>close</mat-icon>
              </button>
            </span>
            <button type="button" class="aca-wfb__outline aca-wfb__vadd" (click)="addAllowed('group')">
              <mat-icon>group_add</mat-icon>{{ 'DMS.BUILDER.VIS_ADD_GROUP' | translate }}
            </button>
          </div>
        </div>
      </div>

      <app-flow-canvas
        [graph]="graph"
        [selection]="selection"
        [problems]="problems"
        [labels]="canvasLabels()"
        (selectionChange)="selection = $event"
        (changed)="onCanvasChanged()"
      />

      <!-- what stops it from being published -->
      <div class="aca-wfb__problems" *ngIf="problems.length; else allGood">
        <h4><mat-icon>report</mat-icon>{{ 'DMS.FLOW.PROBLEMS' | translate: { p0: problems.length } }}</h4>
        <ul>
          <li *ngFor="let p of problems">
            <button type="button" (click)="selectProblem(p)">{{ problemText(p) }}</button>
          </li>
        </ul>
      </div>
      <ng-template #allGood>
        <p class="aca-wfb__ok"><mat-icon>check_circle</mat-icon>{{ 'DMS.FLOW.READY' | translate }}</p>
      </ng-template>

      <div class="aca-wfb__canvasactions">
        <button type="button" class="aca-wfb__outline" (click)="cancelEdit()">
          <mat-icon>close</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.FBA6EF' | translate }}
        </button>
        <button type="button" class="aca-wfb__outline" (click)="saveTemplate()" [disabled]="busy()">
          <mat-icon>save</mat-icon>{{ 'DMS.FLOW.SAVE_DRAFT' | translate }}
        </button>
        <button
          type="button"
          class="aca-wfb__primary"
          (click)="publish()"
          [disabled]="busy() || problems.length > 0"
          [matTooltip]="(problems.length ? 'DMS.FLOW.PUBLISH_BLOCKED' : 'DMS.FLOW.PUBLISH_HINT') | translate"
        >
          <mat-icon>rocket_launch</mat-icon>{{ 'DMS.FLOW.PUBLISH' | translate }}
        </button>
      </div>
    </section>

    <!-- properties of what is selected -->
    <aside class="aca-wfb__props">
      <h3 class="aca-wfb__panetitle">{{ 'DMS.WORKFLOW_BUILDER.70423A' | translate }}</h3>

      <p class="aca-wfb__panehint" *ngIf="!selectedNode() && !selectedEdge()">{{ 'DMS.FLOW.SELECT_HINT' | translate }}</p>

      <!-- a box -->
      <ng-container *ngIf="selectedNode() as node">
        <p class="aca-wfb__kind">
          <mat-icon>{{ icons[node.kind] }}</mat-icon
          >{{ 'DMS.FLOW.KIND_' + (node.kind | uppercase) | translate }}
        </p>
        <label class="aca-wfb__field">
          <span class="aca-wfb__label">{{ 'DMS.WORKFLOW_BUILDER.83193D' | translate }}</span>
          <input class="aca-wfb__input" [(ngModel)]="node.name" (ngModelChange)="onCanvasChanged()" />
        </label>

        <ng-container *ngIf="node.kind === 'approval' || node.kind === 'task'">
          <label class="aca-wfb__field">
            <span class="aca-wfb__label">{{ 'DMS.WORKFLOW_BUILDER.D6EA64' | translate }}</span>
            <select class="aca-wfb__input" [ngModel]="node.assigneeType ?? 'person'" (ngModelChange)="setAssigneeType(node, $event)">
              <option value="person">{{ 'DMS.WORKFLOW_BUILDER.77DB49' | translate }}</option>
              <option value="group">{{ 'DMS.FLOW.WHO_GROUP' | translate }}</option>
              <option value="initiator">{{ 'DMS.FLOW.WHO_INITIATOR' | translate }}</option>
            </select>
          </label>
          <div class="aca-wfb__field" *ngIf="node.assigneeType !== 'initiator'">
            <span class="aca-wfb__label">{{ 'DMS.WORKFLOW_BUILDER.DE2B60' | translate }}</span>
            <div class="aca-wfb__assignee">
              <span class="aca-wfb__assigneename">{{ node.assigneeLabel || node.assignee || ('DMS.UI.166D8C' | translate) }}</span>
              <button type="button" class="aca-wfb__outline" (click)="chooseAssignee(node)">
                <mat-icon>person_search</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.D06907' | translate }}
              </button>
            </div>
          </div>
          <p class="aca-wfb__panehint" *ngIf="node.kind === 'approval'">{{ 'DMS.FLOW.APPROVAL_PATHS' | translate }}</p>
          <p class="aca-wfb__panehint" *ngIf="node.assigneeType === 'group'">{{ 'DMS.FLOW.GROUP_HINT' | translate }}</p>
        </ng-container>

        <p class="aca-wfb__panehint" *ngIf="node.kind === 'condition'">{{ 'DMS.FLOW.CONDITION_HINT' | translate }}</p>
        <p class="aca-wfb__panehint" *ngIf="node.kind === 'parallel'">{{ 'DMS.FLOW.PARALLEL_HINT' | translate }}</p>

        <div class="aca-wfb__propactions">
          <button type="button" class="aca-wfb__danger" (click)="deleteSelected()" [disabled]="node.kind === 'start'">
            <mat-icon>delete_outline</mat-icon>{{ 'DMS.WORKFLOW_BUILDER.EBCC81' | translate }}
          </button>
        </div>
      </ng-container>

      <!-- a line -->
      <ng-container *ngIf="selectedEdge() as edge">
        <p class="aca-wfb__kind"><mat-icon>trending_flat</mat-icon>{{ nodeName(edge.from) }} → {{ nodeName(edge.to) }}</p>

        <label class="aca-wfb__field" *ngIf="sourceOf(edge)?.kind === 'approval'">
          <span class="aca-wfb__label">{{ 'DMS.FLOW.WHEN' | translate }}</span>
          <select class="aca-wfb__input" [ngModel]="edge.outcome ?? 'both'" (ngModelChange)="setOutcome(edge, $event)">
            <option value="approve">{{ 'DMS.FLOW.OUT_APPROVE' | translate }}</option>
            <option value="reject">{{ 'DMS.FLOW.OUT_REJECT' | translate }}</option>
            <option value="both">{{ 'DMS.FLOW.OUT_BOTH' | translate }}</option>
          </select>
        </label>

        <ng-container *ngIf="sourceOf(edge)?.kind === 'condition'">
          <label class="aca-wfb__check">
            <input type="checkbox" [checked]="!!edge.isDefault" (change)="setDefault(edge, $any($event.target).checked)" />
            <span>{{ 'DMS.FLOW.OTHERWISE_PATH' | translate }}</span>
          </label>
          <div class="aca-wfb__field" *ngIf="!edge.isDefault && edge.condition as cond">
            <span class="aca-wfb__label">{{ 'DMS.FLOW.WHEN' | translate }}</span>
            <div class="aca-wfb__cond">
              <input
                class="aca-wfb__input aca-wfb__condfield"
                [(ngModel)]="cond.field"
                (ngModelChange)="onCanvasChanged()"
                placeholder="dms:amount"
                [attr.aria-label]="'DMS.BUILDER.COND_FIELD' | translate"
              />
              <select
                class="aca-wfb__input aca-wfb__condop"
                [(ngModel)]="cond.op"
                (ngModelChange)="onCanvasChanged()"
                [attr.aria-label]="'DMS.BUILDER.COND_OP' | translate"
              >
                <option *ngFor="let op of condOps" [ngValue]="op">{{ opLabel(op) }}</option>
              </select>
              <input
                class="aca-wfb__input aca-wfb__condvalue"
                *ngIf="cond.op !== 'empty' && cond.op !== 'notEmpty'"
                [(ngModel)]="cond.value"
                (ngModelChange)="onCanvasChanged()"
                [placeholder]="'DMS.BUILDER.COND_VALUE' | translate"
                [attr.aria-label]="'DMS.BUILDER.COND_VALUE' | translate"
              />
            </div>
            <span class="aca-wfb__condhint">{{ 'DMS.FLOW.FIELD_HINT' | translate }}</span>
          </div>
        </ng-container>

        <div class="aca-wfb__propactions">
          <button type="button" class="aca-wfb__danger" (click)="deleteSelected()">
            <mat-icon>delete_outline</mat-icon>{{ 'DMS.FLOW.DELETE_LINE' | translate }}
          </button>
        </div>
      </ng-container>
    </aside>
  </div>
</div>
